import { render, staticRenderFns } from "./InventoryItemMaster.vue?vue&type=template&id=5b41a179&"
import script from "./InventoryItemMaster.vue?vue&type=script&lang=js&"
export * from "./InventoryItemMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports